import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const AiSemiIcon = {
  name: 'AiSemiIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || (s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x');
      }
    },
    // Merged into a single 'gradient' prop
    gradient: {
      type: Array,
      default: () => ['currentColor', 'currentColor'], // Default for a two-color gradient
      validator: function (arr) {
        return arr.length === 2 && typeof arr[0] === 'string' && typeof arr[1] === 'string'; // Must be an array of two strings
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x'
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;

    // Destructure the single gradient prop
    const [gradientStartColor, gradientEndColor] = ctx.props.gradient;

    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "42",
        height: "38",
        viewBox: "-5 0 50 38",
        fill: "none", 
      },
      "class": "feather feather-ai-semi"
    }, ctx.data]), [
      h("defs", {}, [
        // Linear gradient for the first path (stroke)
        h("linearGradient", {
          attrs: {
            id: "paint0_linear_3168_50400",
            x1: "21.4897",
            y1: "5",
            x2: "0.989747",
            y2: "25.5",
            gradientUnits: "userSpaceOnUse"
          }
        }, [
          h("stop", { attrs: { "stop-color": gradientStartColor } }),
          h("stop", { attrs: { offset: "1", "stop-color": gradientEndColor } })
        ]),
        // Linear gradient for the second path (stroke)
        h("linearGradient", {
          attrs: {
            id: "paint1_linear_3168_50400",
            x1: "25.1863",
            y1: "21.1718",
            x2: "1.45812",
            y2: "38.2372",
            gradientUnits: "userSpaceOnUse"
          }
        }, [
          h("stop", { attrs: { "stop-color": gradientStartColor } }),
          h("stop", { attrs: { offset: "1", "stop-color": gradientEndColor } })
        ])
      ]),
      h("path", {
        attrs: {
          d: "M13.1015 16.9684C17.7455 16.9684 21.5102 13.3938 21.5102 8.98421C21.5102 4.57465 17.7455 1 13.1015 1C8.45756 1 4.69287 4.57465 4.69287 8.98421C4.69287 13.3938 8.45756 16.9684 13.1015 16.9684Z",
          stroke: "url(#paint0_linear_3168_50400)", // Uses the first gradient
          "stroke-width": "0.75",
          "stroke-linecap": "round",
          "stroke-linejoin": "bevel"
        }
      }),
      h("path", {
        attrs: {
          d: "M30.4822 7.92965V8L30.4883 7.82576C30.534 6.55195 31.3709 5.53788 32.4054 5.50325L32.5107 5.5C31.4341 5.53571 30.5331 4.49892 30.4883 3.17316L30.4822 3V3.07035C30.4822 4.41234 29.5997 5.5 28.5107 5.5C29.5997 5.5 30.4822 6.58766 30.4822 7.92965Z",
          fill: gradientStartColor // Fills use the start color of the gradient
        }
      }),
      h("path", {
        attrs: {
          d: "M41.5097 9.99899C38.8175 10.07 36.5658 7.99716 36.4536 5.34497L36.4392 5V5.14103C36.4392 7.82468 34.2328 10 31.5107 10C34.2328 10 36.4392 12.1753 36.4392 14.859V15L36.4547 14.651C36.5679 12.1033 38.6601 10.0761 41.2463 10.0071L41.5107 10L41.5097 9.99899Z",
          fill: gradientStartColor // Fills use the start color of the gradient
        }
      }),
      h("path", {
        attrs: {
          d: "M27.9262 7.55286L27.9041 7V7.2252C27.9041 11.5195 24.5935 15 20.5107 15C24.5944 15 27.9041 18.4815 27.9041 22.7748V23L27.9271 22.4413C28.0981 18.3645 31.2359 15.1208 35.1146 15.0106L35.5107 14.999C31.4721 15.1131 28.0944 11.7969 27.9253 7.55189L27.9262 7.55286Z",
          fill: gradientStartColor // Fills use the start color of the gradient
        }
      }),
      h("path", {
        attrs: {
          d: "M7.57524 15C6.42078 15.734 4.09197 17.4465 2.36028 20.7023C1.36506 22.5654 0.887351 24.3721 0.648497 25.7271C0.52907 26.4046 0.489258 27.0821 0.489258 27.7784V37H25.4893V27.7784C25.4893 27.0821 25.4495 26.4046 25.33 25.7271C25.0912 24.3533 24.6135 22.5654 23.6182 20.7023C21.8866 17.4465 19.5577 15.734 18.4033 15",
          stroke: "url(#paint1_linear_3168_50400)", // Uses the second gradient
          "stroke-width": "0.75",
          "stroke-linecap": "round",
          "stroke-linejoin": "bevel"
        }
      })
    ]);
  }
};

export default AiSemiIcon;